import { Modal } from 'antd';
import { default as React, useState } from 'react';
import { refundEnrolment } from '../../../services/courseEnrolmentService';
import '../../Common/Form.css';
import RefundForm from './RefundForm';

function EnrolmentRefundModal(props) {
  const isVisible = props.isVisible;
  const setIsVisible = props.setIsVisible;
  const { initialValues } = props;
  const [status, setStatus] = useState({
    error: false,
    message: ''
  });

  function onSubmit(values) {
    refundEnrolment(values)
      .then((response) => {
        setStatus({
          type: 'SUCCESS',
          message: 'Refund successfull!'
        });
      })
      .catch((error) => {
        alert('Posting data to the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <Modal
      title={'Refund Enrolment ' + initialValues.courseEnrolmentId}
      onCancel={() => setIsVisible(false)}
      visible={isVisible}
      onSubmit={onSubmit}
      status={status}
      footer={null}>
      <RefundForm
        initialValues={initialValues}
        onSubmit={onSubmit}
        status={status}
        visible={isVisible}></RefundForm>
    </Modal>
  );
}

export default EnrolmentRefundModal;
